import { useEffect, useRef } from "react";
import { Chart } from "chart.js/auto";
import { defaultColors } from "../datas/colors";

export default function BarChartHabilities({
  title,
  colors = defaultColors,
  indexAxis = "x",
}) {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);

  const competencias = [
    { id: "Competência 1", habilidades: ["H1", "H2", "H3", "H4", "H5"] },
    { id: "Competência 2", habilidades: ["H6", "H7", "H8", "H9", "H10"] },
    { id: "Competência 3", habilidades: ["H11", "H12", "H13", "H14", "H15"] },
    { id: "Competência 4", habilidades: ["H16", "H17", "H18", "H19", "H20"] },
    { id: "Competência 5", habilidades: ["H21", "H22", "H23", "H24", "H25"] },
    { id: "Competência 6", habilidades: ["H26", "H27", "H28", "H29", "H30"] },
  ];

  const habilidadesDescricao = {
    H1: "Interpretar historicamente e/ou geograficamente fontes documentais acerca de aspectos da cultura.",
    H2: "Analisar a produção da memória pelas sociedades humanas.",
    H3: "Associar as manifestações culturais do presente aos seus processos históricos.",
    H4: "Comparar pontos de vista expressos em diferentes fontes sobre determinado tema.",
    H5: "Identificar as manifestações ou representações da diversidade do patrimônio cultural e artístico em diferentes sociedades.",
    H6: "Interpretar diferentes representações gráficas e cartográficas dos espaços geográficos.",
    H7: "Identificar os significados histórico-geográficos das relações de poder entre as nações.",
    H8: "Analisar a ação dos estados nacionais no que se refere à dinâmica dos fluxos populacionais e no enfrentamento de problemas de ordem econômico-social.",
    H9: "Comparar o significado histórico-geográfico das organizações políticas e socioeconômicas em escala local, regional ou mundial.",
    H10: "Reconhecer a dinâmica da organização dos movimentos sociais e a importância da participação da coletividade na transformação da realidade histórico-geográfica.",
    H11: "Identificar registros de práticas de grupos sociais no tempo e no espaço.",
    H12: "Analisar o papel da justiça como instituição na organização das sociedades.",
    H13: "Analisar a atuação dos movimentos sociais que contribuíram para mudanças ou rupturas em processos de disputa pelo poder.",
    H14: "Comparar diferentes pontos de vista, presentes em textos analíticos e interpretativos, sobre situação ou fatos de natureza histórico-geográfica acerca das instituições sociais, políticas e econômicas.",
    H15: "Avaliar criticamente conflitos culturais, sociais, políticos, econômicos ou ambientais ao longo da história.",
    H16: "Identificar registros sobre o papel das técnicas e tecnologias na organização do trabalho e/ou da vida social.",
    H17: "Analisar fatores que explicam o impacto das novas tecnologias no processo de territorialização da produção.",
    H18: "Analisar diferentes processos de produção ou circulação de riquezas e suas implicações socioespaciais.",
    H19: "Reconhecer as transformações técnicas e tecnológicas que determinam as várias formas de uso e apropriação dos espaços rural e urbano.",
    H20: "Selecionar argumentos favoráveis ou contrários às modificações impostas pelas novas tecnologias à vida social e ao mundo.",
    H21: "Identificar o papel dos meios de comunicação na construção da vida social.",
    H22: "Analisar as lutas sociais e conquistas obtidas no que se refere às mudanças nas legislações ou nas políticas públicas.",
    H23: "Analisar a importância dos valores éticos na estruturação política das sociedades.",
    H24: "Relacionar cidadania e democracia na organização das sociedades.",
    H25: "Identificar estratégias que promovam formas de inclusão social.",
    H26: "Identificar em fontes diversas o processo de ocupação dos meios físicos e as relações da vida humana com a paisagem.",
    H27: "Analisar de maneira crítica as interações da sociedade com o meio físico, levando em consideração aspectos históricos e(ou) geográficos.",
    H28: "Relacionar o uso das tecnologias com os impactos socioambientais em diferentes contextos histórico-geográficos.",
    H29: "Reconhecer a função dos recursos naturais na produção do espaço geográfico, relacionando-os com as mudanças provocadas pelas ações humanas.",
    H30: "Avaliar as relações entre preservação e degradação da vida no planeta nos diferentes contextos históricos e geográficos.",
  };

  const labels = competencias.map((comp) => comp.id);
  const habilidades = competencias.map((comp) => comp.habilidades);
  const dataValues = competencias.map(
    (comp) => comp.habilidades.length * Math.floor(Math.random() * 80)
  );

  useEffect(() => {
    if (chartInstance.current) {
      chartInstance.current.destroy();
    }

    const ctx = chartRef.current.getContext("2d");
    chartInstance.current = new Chart(ctx, {
      type: "bar",
      data: {
        labels: labels,
        datasets: [
          {
            data: [57, 53, 58, 40, 39, 49],
            backgroundColor: colors,
            borderRadius: 12,
          },
          {
            data: [47, 44, 41, 50, 37, 49],
            backgroundColor: colors,
            borderRadius: 12,
          },
          {
            data: [57, 56, 43, 52, 48, 39],
            backgroundColor: colors,
            borderRadius: 12,
          },
          {
            data: [42, 36, 46, 42, 36, 43],
            backgroundColor: colors,
            borderRadius: 12,
          },
          {
            data: [49, 29, 58, 35, 46, 41],
            backgroundColor: colors,
            borderRadius: 12,
          },
        ],
      },
      options: {
        indexAxis: indexAxis,
        responsive: true,
        maintainAspectRatio: false,
        layout: {
          padding: {
            left: 10,
            right: 20,
          },
        },
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            enabled: true,
            backgroundColor: "#ffffff", // Fundo branco
            titleColor: "#333333", // Cor do título mais escura para melhor leitura
            titleFont: { weight: "bold", size: 14 }, // Fonte do título mais destacada
            bodyColor: "#444444", // Cor do corpo (habilidade + descrição)
            bodyFont: { size: 13 }, // Tamanho da fonte do corpo
            footerColor: "#1565C0", // Azul mais sofisticado para o footer
            footerFont: { weight: "bold", size: 12 }, // Fonte do footer destacada
            borderColor: "#DDDDDD", // Borda cinza clara
            borderWidth: 1,
            cornerRadius: 10, // Cantos mais arredondados
            padding: 12, // Mais espaço para melhor visualização
            displayColors: false,
            callbacks: {
              // title: (context) => `${context[0].label} - ${context[0].raw}`,
              label: (context) =>
                `${habilidades[context.dataIndex][context.datasetIndex]} - ${
                  habilidadesDescricao[
                    habilidades[context.dataIndex][context.datasetIndex]
                  ]
                }`,
              footer: (context) => {
                if (context.length > 0) {
                  return `📊 Valor: ${context[0].raw}`; // Exibe o valor da barra no footer
                }
                return "SEXO SEXO";
              },
            },
          },
        },
        scales: {
          x: {
            beginAtZero: true,
            grid: {
              display: false,
              drawBorder: false,
              color: "#e5e7eb",
            },
            ticks: {
              font: {
                size: 13,
              },
              color: "#374151",
            },
          },
          y: {
            beginAtZero: true,
            grid: {
              display: true,
              drawBorder: false,
              color: "#e5e7eb",
            },
            ticks: {
              font: {
                size: 14,
                weight: "bold",
              },
              color: "#1f2937",
              padding: 10,
            },
          },
        },
      },
    });

    return () => chartInstance.current.destroy();
  }, []);

  return (
    <div className="w-full p-6 bg-white shadow-lg rounded-xl border border-gray-200">
      <h2 className="text-lg font-bold text-gray-900">{title}</h2>
      <p className="text-gray-500 text-sm">2009 - 2023</p>
      <div className="relative w-full h-72 mt-4">
        <canvas ref={chartRef}></canvas>
      </div>
    </div>
  );
}
